import React, { Component, useState } from "react";
import "leaflet/dist/leaflet.css";

export default function PerformanceWork() {
  return (
    <table className="KPIs-table">
      <tr>
        <th>Strategic Imperative</th>
        <th>KPI</th>
        <th>Unit</th>
        <th>Weight (%)</th>
        <th>
          <div>Target</div>
          <div>YTD</div>
        </th>
        <th>
          <div>Actual</div>
          <div>YTD</div>
        </th>
        <th>%Achieved</th>
        <th>Score</th>
        <th>
          <div>Actual</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Feb</div>
        </th>
        <th>
          <div>Mar</div>
          <div>Jan</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Apr</div>
        </th>
        <th>
          <div>Actual</div>
          <div>May</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jun</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Jul</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Aug</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Sep</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Oct</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Nov</div>
        </th>
        <th>
          <div>Actual</div>
          <div>Dec</div>
        </th>
      </tr>
      <tr className="table-collapse">
        <td colspan="2" style={{ border: "none", background: "#05e8e2" }}>
          เพิ่มประสิทธิภาพการทำงาน
        </td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
        <td style={{ border: "none", background: "#05e8e2" }}></td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>ผลิตต่อเนื่อง ลดเวลาสูญเสีย</td>
        <td>สัดส่วนชั่วโมงการทำงานจริง</td>
        <td>%</td>
        <td>1.0%</td>
        <td>86%</td>
        <td>92%</td>
        <td>107%</td>
        <td>5</td>
        <td>89%</td>
        <td>87%</td>
        <td>91%</td>
        <td>91%</td>
        <td>91%</td>
        <td>94%</td>
        <td>93%</td>
        <td>95%</td>
        <td>95%</td>
        <td>93%</td>
        <td>94%</td>
        <td>92%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>ลดคอขวดในกระบวนการ - โรงงานแปรรูป </td>
        <td>De-Bottleneck Improvement - โรงงานแปรรูป </td>
        <td>%</td>
        <td>0.0%</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>-</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>เปลี่ยนเครื่องจักรเดิม ด้วยเทคโนโลยีใหม่ - โรงงานแปรรูป</td>
        <td>%Capacity Improvement - โรงงานแปรรูป</td>
        <td>%</td>
        <td>0.0%</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td>-</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>-</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>จัดทำ SKU Rationalization</td>
        <td>สัดส่วนสินค้าในกลุ่มสีเขียว ( EP 1-3 )</td>
        <td>%</td>
        <td>1.0%</td>
        <td>7%</td>
        <td>10%</td>
        <td>151%</td>
        <td>5</td>
        <td>8%</td>
        <td>6%</td>
        <td>6%</td>
        <td>9%</td>
        <td>9%</td>
        <td>8%</td>
        <td>6%</td>
        <td>8%</td>
        <td>9%</td>
        <td>11%</td>
        <td>11%</td>
        <td>10%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>จัดทำ SKU Rationalization</td>
        <td>สัดส่วนสินค้าในกลุ่มสีแดง ( NI 1 )</td>
        <td>%</td>
        <td>1.0%</td>
        <td>1%</td>
        <td>1%</td>
        <td>88%</td>
        <td>3</td>
        <td>1%</td>
        <td>2%</td>
        <td>1%</td>
        <td>1%</td>
        <td>1%</td>
        <td>1%</td>
        <td>1%</td>
        <td>1%</td>
        <td>1%</td>
        <td>1%</td>
        <td>1%</td>
        <td>1%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>Supply & Demand Optimization</td>
        <td>%Service Level</td>
        <td>%</td>
        <td>1.5%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>5</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
        <td>100%</td>
      </tr>
      <tr style={{ textAlign: "center" }}>
        <td>จำนวนและอัตราบาดเจ็บจากการทำงานถึงขั้นหยุดงาน</td>
        <td>LTIFR ของพนักงานที่บาดเจ็บถึงขึ้นหยุดงาน</td>
        <td>%</td>
        <td>0.5%</td>
        <td>0.24</td>
        <td>0.21</td>
        <td>115%</td>
        <td>3</td>
        <td></td>
        <td></td>
        <td>-</td>
        <td></td>
        <td></td>
        <td>0.40</td>
        <td></td>
        <td></td>
        <td>-</td>
        <td></td>
        <td></td>
        <td>-</td>
      </tr>
    </table>
  );
}
